/**
 * ImpressionsBuffer - Manages batching of item impressions for GA4 tracking
 * Based on legacy fast_product_page.js impressions buffer pattern
 */
class ImpressionsBuffer {
  constructor() {
    this.queue = []
    this.trackedIds = new Set()
  }

  /**
   * Add an impression to the queue if not already tracked
   * @param {Object} impression - Item data for tracking
   * @returns {boolean} - Whether the impression was added
   */
  addImpressionToQueue(impression) {
    if (!impression || !impression.item_id) {
      return false
    }

    // Prevent duplicate tracking
    if (this.trackedIds.has(impression.item_id)) {
      return false
    }

    this.queue.push(impression)
    this.trackedIds.add(impression.item_id)
    return true
  }

  /**
   * Get current count of queued impressions
   * @returns {number}
   */
  getCount() {
    return this.queue.length
  }

  /**
   * Flush impressions from queue (up to limit)
   * @param {number} limit - Maximum number of impressions to flush
   * @returns {Array} - Array of flushed impressions
   */
  flushImpressions(limit) {
    const itemsToFlush = this.queue.splice(0, limit)
    return itemsToFlush
  }

  /**
   * Clear all queued impressions and tracked IDs
   */
  clear() {
    this.queue = []
    this.trackedIds.clear()
  }

  /**
   * Check if an item has been tracked
   * @param {string|number} itemId
   * @returns {boolean}
   */
  hasTracked(itemId) {
    return this.trackedIds.has(String(itemId))
  }
}

export default ImpressionsBuffer
